/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { CompetenceActivityClass, ProgramData, ProgressCheck } from "@interfaces/Interfaces";
import { useProgramData } from "@hooks/data/useProgramData";

export const useProgramInfo = (programID: string = "") => {
  const { programData } = useProgramData();

  const [program, setProgram] = useState<ProgramData | any | null>(null);
  const [infoBody, setInfoBody] = useState<string | null>(null);

  const [competences, setCompetences] = useState<CompetenceActivityClass[] | any[]>([]);
  const [progressChecks, setProgressChecks] = useState<ProgressCheck[] | any[]>([]);

  useEffect(() => {
    if (programID.length > 0 && programID !== program?.ID) {
      const currentProgram = programData.find((item: any): item is ProgramData => item.ID === programID);

      currentProgram ? setProgram(currentProgram) : setProgram(null);
      currentProgram?.PopupDisclaimer ? setInfoBody(currentProgram.PopupDisclaimer) : setInfoBody(null);
      currentProgram?.CompetenceActivity ? setCompetences(currentProgram.CompetenceActivity) : setCompetences([]);
      currentProgram?.ProgressChecks ? setProgressChecks(currentProgram.ProgressChecks) : setProgressChecks([]);
    }
  }, [programID, program?.ID, program?.PopupDisclaimer]);

  return {
    program,
    infoBody,
    progressChecks,
    competences,
  };
};
